(function () {
  'use strict';

  /* =========================================================
     ATRIANI COMMERCIAL SCENTING
  ========================================================= */

  var BASE_PRICE = 209;
  var BASE_SQFT = 4000;
  var STEP_SQFT = 1000;
  var STEP_PRICE = 60;

  var MAX_SQFT = 35000;

  var INSTALLATION_PRICE = 500;
  var INSTALLATION_PRODUCT_ID = '9608696725763';

  var installationVariantCache = null;
  var currentBaseSubscriptionPrice = null;
  var isAddingPackage = false;

  var repositionTimer = null;


  /* =========================================================
     ELEMENTS
  ========================================================= */

  var sqftInput =
    document.getElementById('sqft-input');

  var hvacInput =
    document.getElementById('hvac-units-input');

  var scentSelect =
    document.getElementById('scent-selection');

  var totalEl =
    document.getElementById('sqft-total');

  var subscriptionSummaryEl =
    document.getElementById('sqft-subscription-summary');

  var subscriptionLabelEl =
    document.getElementById('subscription-summary-label');

  var diffuserLabelEl =
    document.getElementById('diffuser-summary-label');

  var installationLabelEl =
    document.getElementById('installation-summary-label');

  var installationPriceEl =
    document.getElementById('installation-summary-price');

  var renewalTitleEl =
    document.getElementById('renewal-title');

  var renewalNoteEl =
    document.getElementById('renewal-note');

  var renewalAmountEl =
    document.getElementById('renewal-amount');

  var errorEl =
    document.getElementById('sqft-error');

  var quoteNotice =
    document.getElementById('custom-quote-notice');

  var summary =
    document.getElementById('atriani-total-summary');

  var customQuoteWrap =
    document.getElementById(
      'atriani-custom-quote-button-wrap'
    );

  var customQuoteButton =
    document.getElementById(
      'atriani-custom-quote-button'
    );

  var drawer =
    document.getElementById(
      'atriani-commercial-inquiry-drawer'
    );

  var overlay =
    document.getElementById(
      'atriani-inquiry-drawer-overlay'
    );

  var quoteClose =
    document.getElementById(
      'atriani-quote-close'
    );

  var selectionForm =
    document.getElementById(
      'atriani-selection-form'
    );

  var projectDetailsInput =
    document.getElementById(
      'selected-materials-input'
    );


  if (!sqftInput) {
    return;
  }


  /* =========================================================
     SHOPIFY VARIANTS
  ========================================================= */

  var VARIANTS = (function () {
    try {
      var el =
        document.getElementById(
          'sqft-variant-data'
        );

      if (!el) {
        return [];
      }

      return JSON.parse(
        el.textContent
      );
    }

    catch (error) {
      console.error(
        'Atriani: could not parse variant data.',
        error
      );

      return [];
    }
  })();


  var TIER_TO_VARIANT = {};


  VARIANTS.forEach(function (variant) {
    var title =
      String(
        variant.option1 ||
        variant.title ||
        ''
      )
      .replace(/,/g, '')
      .trim();

    var tier =
      parseInt(title, 10);

    if (!isNaN(tier)) {
      TIER_TO_VARIANT[tier] =
        variant;
    }
  });


  /* =========================================================
     HELPERS
  ========================================================= */

  function formatMoney(number) {
    return '$' +
      Number(number).toLocaleString(
        'en-CA',
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }
      );
  }


  function roundCurrency(number) {
    return (
      Math.round(
        Number(number) * 100
      ) / 100
    );
  }


  function getSqft() {
    var value =
      String(
        sqftInput.value || ''
      )
      .replace(/,/g, '')
      .trim();

    var number =
      parseInt(value, 10);

    return isNaN(number)
      ? 0
      : number;
  }


  function getHVACUnits() {
    if (!hvacInput) {
      return 0;
    }

    var number =
      parseInt(
        hvacInput.value,
        10
      );

    if (
      isNaN(number) ||
      number < 1
    ) {
      return 0;
    }

    return number;
  }


  function getSelectedScent() {
    if (!scentSelect) {
      return '';
    }

    return String(
      scentSelect.value || ''
    ).trim();
  }


  function calcTierSqft(sqft) {
    if (sqft <= BASE_SQFT) {
      return BASE_SQFT;
    }

    var extra =
      sqft - BASE_SQFT;

    var steps =
      Math.ceil(
        extra / STEP_SQFT
      );

    return (
      BASE_SQFT +
      steps * STEP_SQFT
    );
  }


  function calcFallbackPrice(tierSqft) {
    if (tierSqft <= BASE_SQFT) {
      return BASE_PRICE;
    }

    var steps =
      (
        tierSqft -
        BASE_SQFT
      ) /
      STEP_SQFT;

    return (
      BASE_PRICE +
      steps * STEP_PRICE
    );
  }


  function getVariantPrice(tierSqft) {
    var variant =
      TIER_TO_VARIANT[
        tierSqft
      ];

    if (
      variant &&
      typeof variant.price !==
        'undefined'
    ) {
      var cents =
        Number(
          variant.price
        );

      if (!isNaN(cents)) {
        return cents / 100;
      }
    }

    return calcFallbackPrice(
      tierSqft
    );
  }


  function showError(message) {
    if (!errorEl) {
      alert(message);
      return;
    }

    errorEl.textContent =
      message;

    errorEl.hidden =
      false;

    errorEl.style.display =
      'block';
  }


  function clearError() {
    if (!errorEl) {
      return;
    }

    errorEl.hidden =
      true;

    errorEl.style.display =
      'none';
  }


  /* =========================================================
     SHOPIFY PRODUCT FORM
  ========================================================= */

  function getProductForm() {
    var forms =
      document.querySelectorAll(
        'form[action*="/cart/add"]'
      );

    var result =
      null;

    forms.forEach(function (form) {
      if (
        form.querySelector(
          '.appstle_subscription_wrapper'
        ) ||
        form.querySelector(
          '[name="selling_plan"]'
        )
      ) {
        result = form;
      }
    });

    return (
      result ||
      document.querySelector(
        'form[action*="/cart/add"]'
      )
    );
  }


  function getAddButton(form) {
    form =
      form ||
      getProductForm();

    if (!form) {
      return null;
    }

    return (
      form.querySelector(
        'button[name="add"]:not([id^="sticky-"])'
      ) ||
      form.querySelector(
        '.product-form__btn:not([id^="sticky-"])'
      )
    );
  }


  /* =========================================================
     APPSTLE
  ========================================================= */

  function getAppstleSelect() {
    var form =
      getProductForm();

    if (!form) {
      return null;
    }

    return form.querySelector(
      '.appstle_select'
    );
  }


  function getSelectedPlanText() {
    var select =
      getAppstleSelect();

    if (
      select &&
      select.options &&
      select.selectedIndex >= 0
    ) {
      return String(
        select.options[
          select.selectedIndex
        ].textContent || ''
      ).trim();
    }

    return 'Monthly Subscription';
  }


  function getSellingPlanId(form) {
    var select =
      form.querySelector(
        '.appstle_select'
      );

    if (
      select &&
      select.value
    ) {
      return select.value;
    }

    var checked =
      form.querySelector(
        'input[name="selling_plan"]:checked'
      );

    if (
      checked &&
      checked.value
    ) {
      return checked.value;
    }

    var field =
      form.querySelector(
        '[name="selling_plan"]'
      );

    if (
      field &&
      field.value
    ) {
      return field.value;
    }

    return null;
  }


  function getPlanInfo() {
    var text =
      getSelectedPlanText();

    if (
      /12[\s-]*month/i.test(text)
    ) {
      return {
        months: 12,
        discount: 0.10,
        label:
          '12-Month Subscription',
        renewalTitle:
          'Subscription Renewal',
        renewalNote:
          'Paid in full · Auto-renews every 12 months',
        renewalSuffix:
          ' / 12 months'
      };
    }

    if (
      /6[\s-]*month/i.test(text)
    ) {
      return {
        months: 6,
        discount: 0.05,
        label:
          '6-Month Subscription',
        renewalTitle:
          'Subscription Renewal',
        renewalNote:
          'Paid in full · Auto-renews every 6 months',
        renewalSuffix:
          ' / 6 months'
      };
    }

    return {
      months: 1,
      discount: 0,
      label:
        'Monthly Subscription',
      renewalTitle:
        'Next Subscription Payment',
      renewalNote:
        'Billed monthly · Auto-renews monthly',
      renewalSuffix:
        '/mo'
    };
  }


  function parseMoney(text) {
    if (!text) {
      return null;
    }

    var cleaned =
      String(text)
      .replace(/[^\d.,-]/g, '')
      .replace(/,/g, '');

    var amount =
      parseFloat(cleaned);

    return isNaN(amount)
      ? null
      : amount;
  }


  function getAppstleDisplayedPrice() {
    var form =
      getProductForm();

    if (!form) {
      return null;
    }

    var active =
      form.querySelector(
        '.appstle_subscription_wrapper_option.appstle-active-option'
      );

    if (!active) {
      active =
        form.querySelector(
          '.appstle_subscription_wrapper_option'
        );
    }

    if (!active) {
      return null;
    }

    var amountEl =
      active.querySelector(
        '.appstle_subscription_amount:not(.appstle_subscription_amount-appstle-sr-only)'
      );

    if (!amountEl) {
      amountEl =
        active.querySelector(
          '.appstle_subscription_amount'
        );
    }

    if (!amountEl) {
      return null;
    }

    return parseMoney(
      amountEl.textContent
    );
  }


  function getFallbackPlanCharge(
    basePrice
  ) {
    var plan =
      getPlanInfo();

    if (
      plan.months === 6
    ) {
      return roundCurrency(
        basePrice *
        6 *
        0.95
      );
    }

    if (
      plan.months === 12
    ) {
      return roundCurrency(
        basePrice *
        12 *
        0.90
      );
    }

    return basePrice;
  }


  /* =========================================================
     SELECT SHOPIFY VARIANT
  ========================================================= */

  function selectVariant(tierSqft) {
    var variant =
      TIER_TO_VARIANT[
        tierSqft
      ];

    if (
      !variant ||
      !variant.id
    ) {
      return false;
    }

    var form =
      getProductForm();

    if (!form) {
      return false;
    }

    var idInput =
      form.querySelector(
        'input[name="id"]'
      );

    if (idInput) {
      idInput.value =
        variant.id;

      idInput.dispatchEvent(
        new Event(
          'input',
          {
            bubbles: true
          }
        )
      );

      idInput.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );
    }


    var root =
      form.closest(
        'product-info, product-form, [data-product-id]'
      );

    if (root) {
      root.dispatchEvent(
        new CustomEvent(
          'variant:change',
          {
            bubbles: true,
            detail: {
              variant: variant
            }
          }
        )
      );
    }


    var blocks =
      document.querySelectorAll(
        '.appstle_subscription_widget [data-variant-id], ' +
        '.appstle_subscription_wrapper [data-variant-id]'
      );

    blocks.forEach(
      function (block) {
        var blockId =
          block.getAttribute(
            'data-variant-id'
          );

        if (!blockId) {
          return;
        }

        block.style.display =
          String(blockId) ===
          String(variant.id)
            ? ''
            : 'none';
      }
    );

    return true;
  }


  /* =========================================================
     SUMMARY
  ========================================================= */

  function updateSummary(
    subscriptionCharge
  ) {
    if (
      subscriptionCharge === null ||
      typeof subscriptionCharge ===
        'undefined'
    ) {
      return;
    }

    var hvacUnits =
      getHVACUnits();

    var installationTotal =
      hvacUnits *
      INSTALLATION_PRICE;

    var total =
      Number(subscriptionCharge) +
      installationTotal;

    var plan =
      getPlanInfo();


    if (subscriptionLabelEl) {
      subscriptionLabelEl.textContent =
        plan.label;
    }


    if (subscriptionSummaryEl) {
      subscriptionSummaryEl.textContent =
        formatMoney(
          subscriptionCharge
        );
    }


    if (diffuserLabelEl) {
      diffuserLabelEl.textContent =
        'Palazzo Scent Diffuser × ' +
        (
          hvacUnits ||
          '—'
        );
    }


    if (installationLabelEl) {
      installationLabelEl.textContent =
        'Professional Installation × ' +
        (
          hvacUnits ||
          '—'
        );
    }


    if (installationPriceEl) {
      installationPriceEl.textContent =
        hvacUnits
          ? formatMoney(
              installationTotal
            )
          : '—';
    }


    if (totalEl) {
      totalEl.textContent =
        hvacUnits
          ? formatMoney(total)
          : '—';
    }


    if (renewalTitleEl) {
      renewalTitleEl.textContent =
        plan.renewalTitle;
    }


    if (renewalNoteEl) {
      renewalNoteEl.textContent =
        plan.renewalNote;
    }


    if (renewalAmountEl) {
      renewalAmountEl.textContent =
        formatMoney(
          subscriptionCharge
        ) +
        plan.renewalSuffix;
    }
  }


  function syncSummaryWithAppstle() {
    if (
      currentBaseSubscriptionPrice ===
      null
    ) {
      return;
    }

    var appstlePrice =
      getAppstleDisplayedPrice();

    /*
      IMPORTANT:
      Once Appstle prepaid plans are configured,
      Appstle should return the FULL prepaid amount.

      If it hasn't updated yet, use our fallback.
    */

    var plan =
      getPlanInfo();

    if (
      appstlePrice !== null &&
      appstlePrice >= 0
    ) {
      /*
        If Appstle still returns a monthly-looking
        price for a prepaid plan, use fallback until
        Appstle is configured correctly.
      */

      if (
        plan.months > 1 &&
        appstlePrice <
          currentBaseSubscriptionPrice * 2
      ) {
        updateSummary(
          getFallbackPlanCharge(
            currentBaseSubscriptionPrice
          )
        );
      }

      else {
        updateSummary(
          appstlePrice
        );
      }
    }

    else {
      updateSummary(
        getFallbackPlanCharge(
          currentBaseSubscriptionPrice
        )
      );
    }
  }


  function scheduleAppstleSync() {
    setTimeout(
      syncSummaryWithAppstle,
      100
    );

    setTimeout(
      syncSummaryWithAppstle,
      350
    );

    setTimeout(
      syncSummaryWithAppstle,
      800
    );
  }


  /* =========================================================
     CUSTOM QUOTE MODE
  ========================================================= */

  function setCustomQuoteMode(enabled) {
    var addButton =
      getAddButton();

    if (enabled) {
      if (addButton) {
        addButton.style.setProperty(
          'display',
          'none',
          'important'
        );

        addButton.disabled =
          true;
      }

      if (customQuoteWrap) {
        customQuoteWrap.hidden =
          false;

        customQuoteWrap.style.setProperty(
          'display',
          'block',
          'important'
        );
      }

      if (summary) {
        summary.style.setProperty(
          'display',
          'none',
          'important'
        );
      }

      if (quoteNotice) {
        quoteNotice.hidden =
          false;
      }
    }

    else {
      if (addButton) {
        addButton.style.removeProperty(
          'display'
        );

        addButton.disabled =
          false;
      }

      if (customQuoteWrap) {
        customQuoteWrap.hidden =
          true;

        customQuoteWrap.style.setProperty(
          'display',
          'none',
          'important'
        );
      }

      if (summary) {
        summary.style.setProperty(
          'display',
          'block',
          'important'
        );
      }

      if (quoteNotice) {
        quoteNotice.hidden =
          true;
      }
    }
  }


  /* =========================================================
     CALCULATOR
  ========================================================= */

  function resetCalculator() {
    currentBaseSubscriptionPrice =
      null;

    if (totalEl) {
      totalEl.textContent = '—';
    }

    if (subscriptionSummaryEl) {
      subscriptionSummaryEl.textContent =
        '—';
    }

    if (installationPriceEl) {
      var hvac =
        getHVACUnits();

      installationPriceEl.textContent =
        hvac
          ? formatMoney(
              hvac *
              INSTALLATION_PRICE
            )
          : '—';
    }

    if (renewalAmountEl) {
      renewalAmountEl.textContent =
        '—';
    }

    clearError();

    setCustomQuoteMode(
      false
    );
  }


  function updateCalculator() {
    clearError();

    var sqft =
      getSqft();


    if (!sqft) {
      resetCalculator();

      updateQuoteDetails();

      return;
    }


    if (
      sqft >
      MAX_SQFT
    ) {
      currentBaseSubscriptionPrice =
        null;

      setCustomQuoteMode(
        true
      );

      updateQuoteDetails();

      positionPurchaseElements();

      return;
    }


    setCustomQuoteMode(
      false
    );


    var tierSqft =
      calcTierSqft(
        sqft
      );

    var matchedVariant =
      TIER_TO_VARIANT[
        tierSqft
      ];


    if (!matchedVariant) {
      currentBaseSubscriptionPrice =
        null;

      if (totalEl) {
        totalEl.textContent =
          'Contact Us';
      }

      if (subscriptionSummaryEl) {
        subscriptionSummaryEl.textContent =
          '—';
      }

      if (renewalAmountEl) {
        renewalAmountEl.textContent =
          '—';
      }

      showError(
        'No matching online subscription plan is currently available for this property size.'
      );

      return;
    }


    currentBaseSubscriptionPrice =
      getVariantPrice(
        tierSqft
      );


    updateSummary(
      getFallbackPlanCharge(
        currentBaseSubscriptionPrice
      )
    );


    selectVariant(
      tierSqft
    );


    scheduleAppstleSync();

    updateQuoteDetails();
  }


  /* =========================================================
     POSITION PURCHASE ELEMENTS
  ========================================================= */

  function positionPurchaseElements() {
    var addButton =
      getAddButton();

    if (!addButton) {
      return;
    }

    var wrapper =
      addButton.closest(
        '.product-form__btn-wrapper'
      );

    if (!wrapper) {
      return;
    }


    /*
      Quote button is placed immediately
      before Add to Cart.
    */

    if (
      customQuoteWrap &&
      customQuoteWrap.parentNode !==
        wrapper
    ) {
      wrapper.insertBefore(
        customQuoteWrap,
        addButton
      );
    }


    /*
      Total summary goes outside the Appstle/
      Add to Cart wrapper to avoid overlap.
    */

    var slot =
      document.getElementById(
        'atriani-total-slot'
      );

    if (!slot) {
      slot =
        document.createElement(
          'div'
        );

      slot.id =
        'atriani-total-slot';
    }


    if (
      wrapper.nextElementSibling !==
      slot
    ) {
      wrapper.insertAdjacentElement(
        'afterend',
        slot
      );
    }


    if (
      summary &&
      summary.parentNode !==
        slot
    ) {
      slot.appendChild(
        summary
      );
    }


    setCustomQuoteMode(
      getSqft() >
      MAX_SQFT
    );
  }


  /* =========================================================
     QUOTE DRAWER
  ========================================================= */

  var quoteScrollY = 0;
  var previousHtmlScrollBehavior = '';


  function updateQuoteDetails() {
    var sqft =
      getSqft();

    var hvac =
      getHVACUnits();

    var scent =
      getSelectedScent() ||
      'Not selected';

    var plan =
      getSelectedPlanText();

    var sqftText =
      sqft
        ? sqft.toLocaleString() +
          ' sq ft'
        : 'Not provided';


    var sqftSummary =
      document.getElementById(
        'quote-summary-sqft'
      );

    var hvacSummary =
      document.getElementById(
        'quote-summary-hvac'
      );

    var scentSummary =
      document.getElementById(
        'quote-summary-scent'
      );

    var planSummary =
      document.getElementById(
        'quote-summary-plan'
      );


    if (sqftSummary) {
      sqftSummary.textContent =
        sqftText;
    }

    if (hvacSummary) {
      hvacSummary.textContent =
        hvac ||
        'Not provided';
    }

    if (scentSummary) {
      scentSummary.textContent =
        scent;
    }

    if (planSummary) {
      planSummary.textContent =
        plan ||
        'Not selected';
    }


    if (projectDetailsInput) {
      projectDetailsInput.value =
        'Property Size: ' +
        sqftText +
        ' | HVAC Units: ' +
        (
          hvac ||
          'Not provided'
        ) +
        ' | Preferred Scent: ' +
        scent +
        ' | Preferred Plan: ' +
        plan;
    }
  }


  function lockPageScroll() {
    quoteScrollY =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      0;

    previousHtmlScrollBehavior =
      document.documentElement.style.scrollBehavior;

    document.documentElement.style.scrollBehavior =
      'auto';

    document.documentElement.classList.add(
      'atriani-inquiry-drawer-lock'
    );

    document.body.classList.add(
      'atriani-inquiry-drawer-lock'
    );

    document.body.classList.add(
      'atriani-inquiry-drawer-open'
    );
  }


  function unlockPageScroll() {
    document.documentElement.classList.remove(
      'atriani-inquiry-drawer-lock'
    );

    document.body.classList.remove(
      'atriani-inquiry-drawer-lock'
    );

    document.body.classList.remove(
      'atriani-inquiry-drawer-open'
    );

    window.scrollTo({
      top: quoteScrollY,
      left: 0,
      behavior: 'auto'
    });

    requestAnimationFrame(
      function () {
        window.scrollTo({
          top: quoteScrollY,
          left: 0,
          behavior: 'auto'
        });

        document.documentElement.style.scrollBehavior =
          previousHtmlScrollBehavior;
      }
    );
  }


  function openQuoteDrawer() {
    if (!drawer) {
      return;
    }

    updateQuoteDetails();

    lockPageScroll();

    drawer.classList.add(
      'is-opened'
    );

    if (overlay) {
      overlay.classList.add(
        'is-visible'
      );
    }
  }


  function closeQuoteDrawer() {
    if (drawer) {
      drawer.classList.remove(
        'is-opened'
      );
    }

    if (overlay) {
      overlay.classList.remove(
        'is-visible'
      );
    }

    unlockPageScroll();
  }


  if (customQuoteButton) {
    customQuoteButton.addEventListener(
      'click',
      function (event) {
        event.preventDefault();

        openQuoteDrawer();
      }
    );
  }


  if (overlay) {
    overlay.addEventListener(
      'click',
      closeQuoteDrawer
    );
  }


  if (quoteClose) {
    quoteClose.addEventListener(
      'click',
      function (event) {
        event.preventDefault();

        event.stopPropagation();

        closeQuoteDrawer();
      }
    );
  }


  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key ===
        'Escape'
      ) {
        closeQuoteDrawer();
      }
    }
  );


  /* =========================================================
     QUOTE FORM
  ========================================================= */

  function showSuccessBadge() {
    var badge =
      document.createElement(
        'div'
      );

    badge.className =
      'atriani-success-badge';

    badge.textContent =
      'Form submitted successfully!';

    document.body.appendChild(
      badge
    );

    setTimeout(
      function () {
        badge.classList.add(
          'visible'
        );
      },
      100
    );

    setTimeout(
      function () {
        badge.classList.remove(
          'visible'
        );

        setTimeout(
          function () {
            badge.remove();
          },
          300
        );
      },
      3000
    );
  }


  if (selectionForm) {
    selectionForm.addEventListener(
      'submit',
      async function (event) {
        event.preventDefault();

        updateQuoteDetails();

        try {
          var formData =
            new FormData(
              selectionForm
            );

          var response =
            await fetch(
              selectionForm.action,
              {
                method:
                  selectionForm.method ||
                  'POST',

                body:
                  formData
              }
            );

          if (response.ok) {
            showSuccessBadge();

            selectionForm.reset();

            closeQuoteDrawer();
          }

          else {
            alert(
              'There was an error submitting the form. Please try again.'
            );
          }
        }

        catch (error) {
          console.error(
            'Atriani quote form:',
            error
          );

          alert(
            'There was an error submitting the form. Please try again.'
          );
        }
      }
    );
  }


  /* =========================================================
     SHOPIFY INSTALLATION PRODUCT
  ========================================================= */

  function getShopifyRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }


  async function resolveInstallationVariant() {
    if (
      installationVariantCache
    ) {
      return installationVariantCache;
    }


    var page = 1;


    while (page <= 20) {
      var response =
        await fetch(
          getShopifyRoot() +
          'products.json?limit=250&page=' +
          page,
          {
            headers: {
              'Accept':
                'application/json'
            }
          }
        );


      if (!response.ok) {
        throw new Error(
          'Could not load the professional installation product.'
        );
      }


      var data =
        await response.json();

      var products =
        data.products || [];


      if (!products.length) {
        break;
      }


      for (
        var i = 0;
        i < products.length;
        i++
      ) {
        var product =
          products[i];

        if (
          String(product.id) ===
          String(
            INSTALLATION_PRODUCT_ID
          )
        ) {
          var variants =
            product.variants || [];

          var availableVariant =
            variants.find(
              function (variant) {
                return (
                  variant.available !==
                  false
                );
              }
            ) ||
            variants[0];


          if (availableVariant) {
            installationVariantCache =
              availableVariant.id;

            return installationVariantCache;
          }
        }
      }

      page++;
    }


    throw new Error(
      'Professional Installation could not be found. Make sure it is active and published to the Online Store.'
    );
  }


  /* =========================================================
     ADD BUTTON LOADING
  ========================================================= */

  function setLoading(
    form,
    loading
  ) {
    var button =
      getAddButton(form);

    if (!button) {
      return;
    }


    if (loading) {
      if (
        !button.dataset.atrianiOriginalHtml
      ) {
        button.dataset.atrianiOriginalHtml =
          button.innerHTML;
      }

      button.disabled =
        true;

      button.textContent =
        'ADDING TO CART...';
    }

    else {
      button.disabled =
        false;

      if (
        button.dataset.atrianiOriginalHtml
      ) {
        button.innerHTML =
          button.dataset.atrianiOriginalHtml;
      }
    }
  }


  /* =========================================================
     CART
  ========================================================= */

  async function addCompletePackage(
    form
  ) {
    if (isAddingPackage) {
      return;
    }


    clearError();


    var sqft =
      getSqft();

    var hvacUnits =
      getHVACUnits();

    var scent =
      getSelectedScent();


    if (
      !sqft ||
      sqft <= 0
    ) {
      showError(
        'Please enter your property size.'
      );

      return;
    }


    if (
      sqft >
      MAX_SQFT
    ) {
      openQuoteDrawer();

      return;
    }


    if (
      hvacUnits <
      1
    ) {
      showError(
        'Please enter the number of HVAC units required.'
      );

      return;
    }


    if (!scent) {
      showError(
        'Please select your preferred scent.'
      );

      return;
    }


    var variantInput =
      form.querySelector(
        'input[name="id"]'
      );


    if (
      !variantInput ||
      !variantInput.value
    ) {
      showError(
        'A subscription size could not be selected.'
      );

      return;
    }


    var sellingPlanId =
      getSellingPlanId(
        form
      );


    if (!sellingPlanId) {
      showError(
        'Please select a subscription plan.'
      );

      return;
    }


    var sellingPlanName =
      getSelectedPlanText();


    isAddingPackage =
      true;

    setLoading(
      form,
      true
    );


    try {
      var installationVariantId =
        await resolveInstallationVariant();


      /*
        IMPORTANT

        We intentionally do NOT add the existing
        Palazzo Scent Diffuser Shopify product here.

        That product is approximately $2,875 and would
        charge the customer.

        Instead, the number of included leased diffusers
        is stored as a line-item property on the
        subscription.

        Installation IS a separate Shopify product and
        its quantity equals the HVAC-unit quantity.
      */

      var cartData = {
        items: [

          /* SUBSCRIPTION */

          {
            id:
              Number(
                variantInput.value
              ),

            quantity: 1,

            selling_plan:
              Number(
                sellingPlanId
              ),

            properties: {
              

              'Included Palazzo Diffusers':
                String(
                  hvacUnits
                ),

              'Diffuser Price':
                '$0 — Included with lease',

              'Preferred Scent':
                scent
            }
          },


          /* INSTALLATION */

          {
            id:
              Number(
                installationVariantId
              ),

            quantity:
              hvacUnits,

            properties: {
              'Installation Rate':
                '$500 per HVAC unit',

              'HVAC Units':
                String(
                  hvacUnits
                ),

              'Property Size':
                sqft.toLocaleString() +
                ' sq ft'
            }
          }

        ]
      };


      console.log(
        'Atriani commercial scenting cart:',
        cartData
      );


      var response =
        await fetch(
          getShopifyRoot() +
          'cart/add.js',
          {
            method:
              'POST',

            headers: {
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body:
              JSON.stringify(
                cartData
              )
          }
        );


      var result =
        await response.json();


      if (!response.ok) {
        console.error(
          'Shopify cart error:',
          result
        );

        throw new Error(
          result.description ||
          result.message ||
          'The package could not be added to your cart.'
        );
      }


      console.log(
        'Atriani cart added successfully:',
        result
      );


      window.location.href =
        getShopifyRoot() +
        'cart';
    }

    catch (error) {
      console.error(
        'Atriani package error:',
        error
      );

      showError(
        error.message ||
        'Something went wrong while adding the package to your cart.'
      );

      setLoading(
        form,
        false
      );

      isAddingPackage =
        false;
    }
  }


  /* =========================================================
     EVENTS
  ========================================================= */

  sqftInput.addEventListener(
    'input',
    function () {
      updateCalculator();

      positionPurchaseElements();
    }
  );


  if (hvacInput) {
    hvacInput.addEventListener(
      'input',
      function () {
        if (
          currentBaseSubscriptionPrice !==
          null
        ) {
          syncSummaryWithAppstle();
        }

        updateQuoteDetails();
      }
    );
  }


  if (scentSelect) {
    scentSelect.addEventListener(
      'change',
      updateQuoteDetails
    );
  }


  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target &&
        (
          event.target.matches(
            '.appstle_select'
          ) ||
          event.target.matches(
            '[name="selling_plan"]'
          )
        )
      ) {
        scheduleAppstleSync();

        updateQuoteDetails();
      }
    }
  );


  /* =========================================================
     INTERCEPT SHOPIFY ADD TO CART
  ========================================================= */

  document.addEventListener(
    'submit',
    function (event) {
      var form =
        event.target;

      if (
        !form ||
        !form.matches(
          'form[action*="/cart/add"]'
        )
      ) {
        return;
      }


      if (
        !document.getElementById(
          'atriani-scent-calculator'
        )
      ) {
        return;
      }


      /*
        We only intercept the form containing
        Appstle subscription controls.
      */

      if (
        !form.querySelector(
          '.appstle_subscription_wrapper, [name="selling_plan"]'
        )
      ) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      if (
        getSqft() >
        MAX_SQFT
      ) {
        openQuoteDrawer();

        return;
      }


      addCompletePackage(
        form
      );
    },
    true
  );


  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initialize() {
    positionPurchaseElements();

    updateCalculator();

    updateQuoteDetails();
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        setTimeout(
          initialize,
          300
        );

        setTimeout(
          positionPurchaseElements,
          900
        );

        setTimeout(
          positionPurchaseElements,
          1500
        );
      }
    );
  }

  else {
    setTimeout(
      initialize,
      300
    );
  }


  /* =========================================================
     APPSTLE MUTATION OBSERVER
  ========================================================= */

  var observer =
    new MutationObserver(
      function () {
        clearTimeout(
          repositionTimer
        );

        repositionTimer =
          setTimeout(
            function () {
              positionPurchaseElements();

              /*
                Appstle may have just refreshed the
                displayed selling-plan price.
              */

              if (
                currentBaseSubscriptionPrice !==
                null
              ) {
                syncSummaryWithAppstle();
              }
            },
            120
          );
      }
    );


  var observerTarget =
    document.querySelector(
      'product-info, .product__info-wrapper'
    ) ||
    document.body;


  observer.observe(
    observerTarget,
    {
      childList: true,
      subtree: true
    }
  );

})();